const SvgProfile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9683_40931)">
        <path
          d="M12 2C9.24746 2 7 4.24746 7 7C7 9.75254 9.24746 12 12 12C14.7525 12 17 9.75254 17 7C17 4.24746 14.7525 2 12 2ZM12 3.5C13.9419 3.5 15.5 5.05812 15.5 7C15.5 8.94188 13.9419 10.5 12 10.5C10.0581 10.5 8.5 8.94188 8.5 7C8.5 5.05812 10.0581 3.5 12 3.5ZM5.98926 14C4.89935 14 4 14.8994 4 15.9893V16.75C4 18.5521 5.13963 19.9461 6.65332 20.7812C8.16701 21.6164 10.0841 22 12 22C13.9159 22 15.833 21.6164 17.3467 20.7812C18.6373 20.0692 19.6087 18.9313 19.8809 17.5H20.001V15.9893C20.001 14.8994 19.1006 14 18.0107 14H5.98926ZM5.98926 15.5H18.0107C18.2898 15.5 18.501 15.7102 18.501 15.9893V16H18.5V16.75C18.5 17.9479 17.8271 18.8039 16.6221 19.4688C15.417 20.1336 13.7091 20.5 12 20.5C10.2909 20.5 8.58299 20.1336 7.37793 19.4688C6.17287 18.8039 5.5 17.9479 5.5 16.75V15.9893C5.5 15.7102 5.71016 15.5 5.98926 15.5Z"
          className="fill-current"
        />
      </g>
      <defs>
        <clipPath id="clip0_9683_40931">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgProfile;
